export default {"src":"/_next/static/media/more.f0eda15a.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};